
// ROUTES
require('modules/invitation-room/routes/invitation-room');

// CONTROLLERS
require('modules/invitation-room/controllers/invitation-room');
require('modules/invitation-room/controllers/list');
require('modules/invitation-room/controllers/assign');
require('modules/invitation-room/controllers/edit');

// SERVICES
require('modules/invitation-room/services/invitation-room');
require('modules/invitation-room/services/list');
require('modules/invitation-room/services/create');
require('modules/invitation-room/services/edit');
require('modules/invitation-room/services/delete');


angular.module('unica_invitation_room', [

	// ROUTES
	'unica_invitation_room.invitation_room_routes',

	// CONTROLLERS
	'unica_invitation_room.invitation_room_controllers',

	// SERVICES
	'unica_invitation_room.invitation_room_services'

]);